export const defaultFun = () => {}
export const makeSlots = (fn) => {
    fn.proxy = true
    return fn
}

export const commentMixIn = (arr = []) => ({
    mixins: arr
})
